import _createForOfIteratorHelper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { addressEqual } from '../..';
export function callsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type === 'ADD_CALLS') {
    return [].concat(_toConsumableArray(state), _toConsumableArray(action.calls));
  } else {
    var finalState = state;

    var _iterator = _createForOfIteratorHelper(action.calls),
        _step;

    try {
      var _loop = function _loop() {
        var call = _step.value;
        var index = finalState.findIndex(function (x) {
          return addressEqual(x.address, call.address) && x.data === call.data;
        });

        if (index !== -1) {
          finalState = finalState.filter(function (_, i) {
            return i !== index;
          });
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return finalState;
  }
}